import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash-es';

import SEARCH_RESULT_TYPE from '../../../../types/search-result-types';
import RouteLabel from '../RouteLabel';

const { ROUTE, STOP, BUS, TRAIN, FERRY } = SEARCH_RESULT_TYPE;

const getLabelFromEntity = (entity, useRouteSearchByRouteId) => {
    const vehicleLabelMap = vehicle => `${capitalize(vehicle.category.type)} ${vehicle.data.label}`;
    if (entity.category.type === ROUTE.type && useRouteSearchByRouteId && entity.data) {
        return <RouteLabel route={ entity.data } />;
    }
    const entityLabelMap = {
        [ROUTE.type]: entity.data.route_short_name,
        [STOP.type]: `${capitalize(entity.category.type)} ${entity.data.stop_code} ${entity.data.stop_name}`,
        [BUS.type]: vehicleLabelMap(entity),
        [TRAIN.type]: vehicleLabelMap(entity),
        [FERRY.type]: vehicleLabelMap(entity),
    };
    return entityLabelMap[entity.category.type];
};

const MultiValueLabel = (props) => {
    const useRouteSearchByRouteId = props.selectProps?.useRouteSearchByRouteId;
    return (
        <components.MultiValueLabel { ...props }>
            { getLabelFromEntity(props.data, useRouteSearchByRouteId) }
        </components.MultiValueLabel>
    );
};

MultiValueLabel.propTypes = {
    data: PropTypes.object.isRequired,
    selectProps: PropTypes.object,
};

MultiValueLabel.defaultProps = {
    selectProps: {},
};

export default MultiValueLabel;
